import { createElement, type HTMLProps } from "react";
import { twMerge } from "tailwind-merge";

export const STYLES = {
  h1: "text-9xl",
  h2: "text-7xl",
  h3: "text-5xl",
  h4: "text-3xl",
  h5: "text-2xl",
  h6: "text-xl",
} as const;

const FONT_FAMILY = {
  sans: "font-sans",
  mono: "font-mono",
} as const;

const FONT_WEIGHT = {
  thin: "font-thin",
  regular: "font-normal",
  bold: "font-bold",
  black: "font-black",
} as const;

type HeadingVariant = keyof typeof STYLES;

interface HeadingMonoProps extends HTMLProps<HTMLElement> {
  variant: HeadingVariant;
  as?: HeadingVariant | "div" | "span";
  family?: "mono";
  weight?: "regular" | "bold";
}

interface HeadingSansProps extends HTMLProps<HTMLElement> {
  variant: HeadingVariant;
  as?: HeadingVariant | "div" | "span";
  family?: "sans";
  weight?: "thin" | "regular" | "bold" | "black";
}

export type HeadingProps = HeadingMonoProps | HeadingSansProps;

export const SupHeading = ({ variant, as = variant, family = "mono", weight = "regular", children, className, ...restProps }: HeadingProps) =>
  createElement(
    as,
    {
      ...restProps,
      className: twMerge("uppercase", STYLES[variant], FONT_FAMILY[family], FONT_WEIGHT[weight], "leading-none tracking-normal", className),
    },
    children
  );
